import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

export const SWITCH_DURATION = 5000;
export const NAVIGATE_DELAY = 1600;
export const STAGE_TIMINGS = [0, 1150, 2400, 3600];
export const COMPLETE_AT = 4450;
export const REVEAL_AT = 4560;


export interface SwitchableApp {
  key: string;
  to?: string;
  prefix?: string;
  title: string;
  tagline?: string;
  description?: string;
  accent?: string;
  accentAlt?: string;
  motif?: string;
  icon?: IconDefinition;
  logo?: string;
  role?: string;
  stages?: string[];
  readyLabel?: string;
}
